import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
import { ApiFactory } from '../agwasuite-api-factory';
import type {
  DataTableDataRequest,
  EmailAuditLogResult,
} from '../agwa-api-model';

/**
 * API client for email audit log operations.
 * Provides endpoints for viewing and searching email audit logs.
 * Only accessible to AGWA staff with MemberAdmin rights.
 */
export class ApiEmailAudit extends AGWASuiteApiClientBase {
  constructor(baseUrl?: string) {
    super(baseUrl);
  }

  /**
   * Search email audit logs with filtering, sorting, and pagination.
   * Requires MemberAdmin rights.
   */
  async searchEmailAuditLogs(
    request: DataTableDataRequest
  ): Promise<ApiResponse<EmailAuditLogResult>> {
    return this.postExecute<DataTableDataRequest, EmailAuditLogResult>(
      '/api/emailaudit/search',
      request
    );
  }
}

/**
 * Get an EmailAuditApi instance.
 * Creates a fresh instance each call to ensure current auth tokens.
 */
export function getEmailAuditApi(): ApiEmailAudit {
  return ApiFactory.authenticated(ApiEmailAudit);
}
